import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\"nw-keyword-table__generic-text\">\n  <p>\n    {{#if @value}}\n      {{@value}}\n    {{else}}\n      /\n    {{/if}}\n  </p>\n</div>")